import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const QUICK_RESULTS = 'QUICK_RESULTS'
export const ADD_QUICK_RESULTS = 'ADD_QUICK_RESULTS'

export const loadRiasecResults = riasec => filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/quick/results`, { riasec, filters })({ type: QUICK_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(initSearchResults(v.results))
  })
}

export const loadSubsequentRiasecResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/profiles/quick/results`, updatedJson)({ type: ADD_QUICK_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
